export default [
    {
        id: 'air-table-record-buffer-layer',
        type: 'fill',
        source: 'air-table-buffer-layer',
        paint: {
            'fill-color': '#ffffff',
            'fill-opacity': 0.6,
        },
        filter: ['all', ['==', ['get', 'isVisible'], true]],
        minzoom: 12,
    },
    {
        id: 'air-table-record-points',
        type: 'circle',
        source: 'air-table-records',
        paint: {
            'circle-radius': 6,
            'circle-color': ['get', 'color'],
            'circle-stroke-color': '#ffffff',
        },
        filter: ['all', ['==', ['get', 'isVisible'], true]],
        minzoom: 12,
    },
    {
        id: 'air-table-record-points-label',
        type: 'symbol',
        source: 'air-table-records',
        layout: {
            'symbol-placement': 'point',
            'text-field': ['get', 'label'],
            'text-size': 13,
        },
        paint: {
            'text-color': '#eee',
            'text-halo-color': 'rgba(0,0,0,0.6)',
            'text-halo-width': 1.2,
        },
        filter: ['all', ['==', ['get', 'isVisible'], true]],
        minzoom: 16,
    },
];
